import { Component } from '@theme/component';

/**
 * Quiz: shows the result message that matches how many checklist cards are ticked. Message 1 is for nothing
 * ticked, message N + 1 for N ticked, and the last message covers any higher count. Without JavaScript the
 * first message stays.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} [verdict] - The result line, a polite live region.
 *
 * @extends {Component<Refs>}
 */
class ChecklistComponent extends Component {
  /** @type {string[]} */
  #messages = [];

  connectedCallback() {
    super.connectedCallback();

    try {
      const parsed = JSON.parse(this.dataset.messages ?? '[]');
      this.#messages = Array.isArray(parsed) ? parsed.filter((message) => typeof message === 'string') : [];
    } catch {
      this.#messages = [];
    }

    // The browser can restore ticked boxes on reload or back navigation.
    this.#renderVerdict();
  }

  /**
   * Updates the result line after a card is ticked or unticked.
   */
  handleChange() {
    this.#renderVerdict();
  }

  #renderVerdict() {
    const { verdict } = this.refs;
    if (!verdict || this.#messages.length === 0) return;

    const ticked = this.querySelectorAll('.pawwji-checklist__input:checked').length;
    const message = this.#messages[Math.min(ticked, this.#messages.length - 1)] ?? '';

    if (verdict.textContent !== message) verdict.textContent = message;
  }
}

if (!customElements.get('pawwji-checklist-component')) {
  customElements.define('pawwji-checklist-component', ChecklistComponent);
}
